var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"pt-1",attrs:{"cols":"12"}},[_c('code-input',{attrs:{"solo":""}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('event-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }